import convertOldSequenceDataToNewDataType from "./convertOldSequenceDataToNewDataType.js";
export default function flattenSequenceArray(parsingResultArray, opts) {
  if (parsingResultArray) {
    if (!Array.isArray(parsingResultArray)) {
      parsingResultArray = [parsingResultArray];
    }
    parsingResultArray.forEach(function(parsingResult) {
      if (parsingResult.success) {
        convertOldSequenceDataToNewDataType(parsingResult.parsedSequence, opts);
      }
    });
  }
  return parsingResultArray;
}
